import { Link } from 'react-router-dom';
import { BaytarcLogo } from '@/components/brand/BaytarcLogo';

export interface BrandedErrorPageProps {
  code?: string;
  title: string;
  message: string;
  /** Shown when there's an actual error to inspect (dev only, matches ErrorBoundary's convention). */
  detail?: string;
  onReload?: () => void;
}

export function BrandedErrorPage({ code, title, message, detail, onReload }: BrandedErrorPageProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-secondary-50 via-primary-50/30 to-secondary-50 px-6 py-12">
      <Link to="/" className="mb-10">
        <BaytarcLogo variant="navy" size="lg" />
      </Link>

      <div className="w-full max-w-md text-center">
        {code && (
          <p className="font-display text-6xl font-bold text-primary-600 mb-2">{code}</p>
        )}
        <h1 className="text-2xl font-bold text-secondary-900">{title}</h1>
        <p className="mt-3 text-secondary-600">{message}</p>

        {import.meta.env.DEV && detail && (
          <pre className="mt-6 max-h-32 overflow-auto rounded-lg bg-secondary-100 p-3 text-left text-xs text-red-700">
            {detail}
          </pre>
        )}

        <div className="mt-8 flex justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg bg-primary-600 px-5 py-2.5 text-sm font-semibold text-white shadow-md transition-colors hover:bg-primary-700"
          >
            Take me home
          </Link>
          <button
            onClick={onReload ?? (() => window.location.reload())}
            className="inline-flex items-center justify-center rounded-lg border border-secondary-300 bg-white px-5 py-2.5 text-sm font-semibold text-secondary-700 shadow-sm transition-colors hover:bg-secondary-50"
          >
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}
